<script>

import Contact from "./contact";
import Engineer from "./engineer";
import uploadAvatar from "@/views/widgets/upload-files/upload-avatar";
import DatePickr from "@/views/widgets/date-pickr";
import Qualification from "./qualification";
import AccountList from "../components/account-list.vue";
import {serviceCompanyDetail,patchServiceCompany, getCompanyInfo} from "@/service";
import {INDUSTRY_TXT, INDUSTRY, COMPANY_SIZE_TXT, COMPANY_SIZE} from "@/config/common";
import {successMsg, alertError} from "@/helpers/swal";
import {isValidEmail} from "@/helpers/common";
import LocationSelect from "@/views/widgets/location-select";

export default {
  props: {
    source: {
      type: String,
      default: "business-partner", // 来源：business-partner 从商业伙伴过来  user-center: 从用户中心过来
    },
    // 企业账户权限code，有此权限才能查看企业账户
    accountPermissionCode: {
      type: String,
      default: "",
    },
    // 企业账户编辑权限code, 有此权限才能编辑企业账户
    accountEditPermissionCode: {
      type: String,
      default: "",
    },
    // 其余信息查看权限code，有此权限才能查看其余信息
    otherPermissionCode: {
      type: String,
      default: "",
    },
    // 其余信息编辑权限code，有此权限才能编辑其余信息
    otherEditPermissionCode: {
      type: String,
      default: "",
    },
    companyId: {
      type: [String, Number],
      default: null
    },
  },
  data() {
    return {
      INDUSTRY_TXT,
      INDUSTRY,
      COMPANY_SIZE_TXT,
      COMPANY_SIZE,
      title: this.$t('page.service-company'),
      checkTabVal: '1',
      serviceCompany: {
        logo: '',
        name: '',
        introduce: '',
        industry: '',
        tel: '',
        email: '',
        web: '',
        address: '',
        build_at: '',
        size: '',
      },
      companyEditing: false,
    };
  },
  components: {
    Contact,
    Engineer,
    uploadAvatar,
    DatePickr,
    Qualification,
    Account : AccountList,
    LocationSelect,
  },
  computed: {
    tabOptions() {
      const options = [];
      if (this.hasPermissionFor(this.otherPermissionCode)) {
        options.push({
          value: '1',
          text: this.$t('page.business-partner.contact')
        });
        options.push({
          value: '2',
          text: this.$t('page.engineer')
        });
        options.push({
          value: '3',
          text: this.$t('page.business-partner.qualification')
        });
      }
      if (this.hasPermissionFor(this.accountPermissionCode) && this.source !== 'user-center') {
        options.push({
          value: '4',
          text: this.$t('page.business-account')
        });
      }
      return options;
    }
  },
  watch: {

  },
  mounted() {
    this.getDetail()
  },

  methods: {
    getDetail() {
      if (this.source === 'user-center') {
        getCompanyInfo().then(res => {
          this.serviceCompany = res.payload
        })
        return
      }
      serviceCompanyDetail(this.companyId).then(res => {
        // console.log(res)
        this.serviceCompany = res.payload
      })
    },
    editServiceCompany() {
      this.companyEditing = true
    },
    // 修改选择地区后
    locationSelected(selected) {
      if (selected) {
        this.serviceCompany.country = selected[0]
        this.serviceCompany.province = selected[1]
        this.serviceCompany.city = selected[2]
      } else {
        this.serviceCompany.country = null
        this.serviceCompany.province = null
        this.serviceCompany.city = null
      }
    },
    saveServiceCompany() {
      if (this.serviceCompany.email && !isValidEmail(this.serviceCompany.email)) {
        alertError(this.$t('base.prompt'), this.$t('page.wrongEmailFormat'))
        return
      }
      patchServiceCompany(this.serviceCompany).then(() => {
        successMsg(this.$t('base.modified_successfully'))
        this.companyEditing = false
        this.getDetail()
      }).catch(err => {
        console.log(err)
        alertError(this.$t('base.prompt'), this.$t('base.an-error-occurred'))
      })
    },
    cancelEditing() {
      this.companyEditing = false
      this.getDetail()
    }
  },
};
</script>

<template>
  <div>
    <b-row align-v="stretch">
      <b-col cols="9">
        <b-card no-body class="mb-0 border-bottom">
          <b-card-header class="border-0">
            <ul class="nav nav-tabs-custom card-header-tabs border-bottom-0" role="tablist">
              <li class="nav-item" v-for="(item, index) in tabOptions" :key="index" @click="checkTabVal = item.value">
                <b-link class="nav-link fw-semibold" :class="item.value == checkTabVal ? 'active' : ''" role="tab">
                  {{ item.text }}
                </b-link>
              </li>
            </ul>
          </b-card-header>
        </b-card>
        <Contact v-if="checkTabVal == '1'" :edit-permission-code="otherEditPermissionCode" :get-permission-code="otherPermissionCode"></Contact>
        <Engineer v-if="checkTabVal == '2'"></Engineer>
        <Qualification v-if="checkTabVal == '3'" :edit-permission-code="otherEditPermissionCode"></Qualification>
        <Account
            v-if="checkTabVal == '4' && companyId"
            type="organization"
            :belong_id="companyId"
            belong_type="service_company"
            :get-permission-code="accountPermissionCode"
            :patch-permission-code="accountEditPermissionCode"
            :post-permission-code="accountEditPermissionCode"
            :freeze-permission-code="accountEditPermissionCode"
            :reset-permission-code="accountEditPermissionCode"
            @added="getDetail"
        ></Account>
      </b-col>
      <b-col cols="3" v-perm="otherPermissionCode">
        <b-card no-body class="mb-0">
          <b-card-body class="p-4">
            <div>
              <div class="d-flex justify-content-end btns-wrapper">
                <div v-if="companyEditing" class="avatar-sm circle-btn">
                  <div class="avatar-title rounded-circle bg-body text-primary cursor-pointer" @click="saveServiceCompany">
                    <i class="ri-check-line"></i>
                  </div>
                </div>
                <div v-if="!companyEditing" class="avatar-sm circle-btn" @click="editServiceCompany" v-perm="otherEditPermissionCode">
                  <div class="avatar-title rounded-circle bg-body text-primary cursor-pointer">
                    <i class="ri-edit-2-line"></i>
                  </div>
                </div>
              </div>
              <div class="flex-shrink-0 avatar-md mx-auto mt-3">
                <upload-avatar :value="serviceCompany.logo" :upload-disable="!companyEditing" v-model="serviceCompany.logo" input-id="uploadCompanyLogo" filename-prefix="sc" return-type="url"></upload-avatar>
              </div>
              <div class="mt-4 text-center">
                <h5 class="mb-1" v-if="!companyEditing">{{ serviceCompany.name }}</h5>
                <input v-else type="text" class="form-control" v-model="serviceCompany.name" />
              </div>
              <div class="mt-4">
                <span class="fw-medium">{{ $t('page.companyIntroduction') }}</span>
                <p class="mt-2" v-if="!companyEditing">{{ serviceCompany.introduce }}</p>
                <textarea v-else class="form-control mt-2" rows="6" v-model="serviceCompany.introduce"></textarea>
              </div>
              <div class="table-responsive">
                <table class="table mb-0 table-borderless">
                  <tbody>
                  <tr>
                    <th :class="!companyEditing?'min-w-90':''"><span class="fw-medium">{{ $t('page.industry') }}</span></th>
                    <td>
                      <span v-if="!companyEditing">{{ INDUSTRY_TXT[serviceCompany.industry] }}</span>
                      <Multiselect
                          v-else
                          class="form-control"
                          :can-clear="false"
                          :can-deselect="false"
                          v-model="serviceCompany.industry"
                          :close-on-select="true"
                          :searchable="true"
                          :create-option="false"
                          :placeholder="$t('page.select-industry')"
                          :options="INDUSTRY"
                      />
                    </td>
                  </tr>
                  <tr v-if="!companyEditing && source === 'business-partner'">
                    <th class="min-w-90"><span class="fw-medium">{{ $t('page.registerStatus') }}</span></th>
                    <td>
                      <span>{{ serviceCompany.register_status ? this.$t('page.registered') : this.$t('page.unregistered') }}</span>
                    </td>
                  </tr>
                  <tr>
                    <th><span class="fw-medium">{{ $t('page.contactNumber') }}</span></th>
                    <td>
                      <span v-if="!companyEditing">{{ serviceCompany.tel }}</span>
                      <input v-else type="text" class="form-control" v-model="serviceCompany.tel" />
                    </td>
                  </tr>
                  <tr>
                    <th><span class="fw-medium">{{ $t('page.email') }}</span></th>
                    <td>
                      <span v-if="!companyEditing">{{ serviceCompany.email }}</span>
                      <input v-else type="text" class="form-control" v-model="serviceCompany.email" />
                    </td>
                  </tr>
                  <tr>
                    <th><span class="fw-medium">{{ $t('page.officialWebsite') }}</span></th>
                    <td>
                      <span v-if="!companyEditing">{{ serviceCompany.web }}</span>
                      <input v-else type="text" class="form-control" v-model="serviceCompany.web" />
                    </td>
                  </tr>
                  <tr>
                    <th><span class="fw-medium">{{ $t('page.companyAddress') }}</span></th>
                    <td>
                      <div v-if="!companyEditing">
                        {{ serviceCompany.country_txt }}{{ serviceCompany.province_txt }}{{ serviceCompany.city_txt }}{{ serviceCompany.address }}
                      </div>
                      <template v-else>
                        <location-select
                            :selected-location="[serviceCompany.country, serviceCompany.province, serviceCompany.city]"
                            @selected="locationSelected"
                        ></location-select>
                        <input type="text" class="form-control" v-model="serviceCompany.address" />
                      </template>
                    </td>
                  </tr>
                  <tr>
                    <th><span class="fw-medium">{{ $t('page.establishedTime') }}</span></th>
                    <td>
                <span v-if="!companyEditing">
                  {{ serviceCompany.build_at }}
                </span>
                      <DatePickr v-else :value="serviceCompany.build_at" v-model="serviceCompany.build_at" />
                    </td>
                  </tr>
                  <tr>
                    <th><span class="fw-medium">{{ $t('page.companySize') }}</span></th>
                    <td>
                      <span v-if="!companyEditing">
                        {{ COMPANY_SIZE_TXT[serviceCompany.size] }}
                      </span>
                      <Multiselect
                          v-else
                          class="form-control"
                          :can-clear="false"
                          :can-deselect="false"
                          v-model="serviceCompany.size"
                          :close-on-select="true"
                          :searchable="true"
                          :create-option="false"
                          :placeholder="$t('page.please-select-company-size')"
                          :options="COMPANY_SIZE"
                      />
                    </td>
                  </tr>
                  </tbody>
                </table>
                <div v-if="companyEditing" class="d-flex justify-content-end">
                  <button class="btn btn-light me-4 px-4" @click="cancelEditing">{{ $t('base.cancel') }}</button>
                  <button class="btn btn-primary px-4" @click="saveServiceCompany">{{ $t('base.save') }}</button>
                </div>
              </div>
            </div>
          </b-card-body>
        </b-card>
      </b-col>
    </b-row>
  </div>

</template>
<style scoped>
.btns-wrapper {
  position: absolute;
  top: 10px;
  right: 10px;
}
.circle-btn {
  width: 2.5rem;
  height: 2.5rem;
  font-size: 1.4rem;
}
</style>
